<template>
  <div class="classItem">
    <div class="img" :style="{
      backgroundImage: `url('${thumb}')`,
      ...isChecked && { boxShadow: `inset 0 0 0 1px ${getPointColor}`, borderColor: getPointColor }
    }"></div>
    <div class="name">{{ item.collectionItemName[lang] }}</div>
  </div>
</template>

<script>
export default {
  name: 'CollectionGroupItem',
  props: [
    'locale',
    'lang',
    'categoryId',
    'item',
    'isChecked'
  ],
  computed: {
    getPointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    thumb () {
      return this.item.attribute.image
    }
  },
  methods: {
  }
}
</script>